// initial state
const state = {
	detailInfo: {},  //商品详情
	isShowcartInfo: false,  //是否显示购物车
	number: 0,   //选择商品的数量
	// ispromotion: false,  //点击促销， 根据该值来判断弹出框距离底部的距离
	type: '确定',  //点击购买和加入购物车， 购买浮层的按钮显示
	chooseinfo: {
		specification: [],
		ids: []
	},  //选择该商品的ids和属性名称
	properties: [],  //多属性商品的属性名称值
	index: 0,  //当前点击的type值
	currentProductId: '',  //当前商品的id
	isPreviewPicture: false, //当前是否是预览大图
	swipeId: 0,  //当前滑动的swiperid值
	promoPopstatus: false,
}

// mutations
const mutations = {

	// 保存商品详情， 各个组件数据共享
	saveDetailInfo(state, value) {
		// let state = JSON.parse(JSON.stringify(state))
		state.detailInfo = value
		// state = s
	},

	// 根据点击时是否显示购物车浮层
	saveCartState(state, value) {
		// let state = JSON.parse(JSON.stringify(state))
		state.isShowcartInfo = value
		// state = s
	},

	// 保存选择的商品的数量
	saveNumber(state, number) {
		// let state = JSON.parse(JSON.stringify(state))
		state.number = number
		// state = s
	},

	// 加入购物车，还是确定的文案设置
	changeType(state, value) {
		// let state = JSON.parse(JSON.stringify(state))
		state.type = value
		// state = s
	},

	//保存当钱切换的tab值
	changeIndex(state, value) {
		// let state = JSON.parse(JSON.stringify(state))
		state.index = value
		// state = s
	},

	// 设置当前商品的id值
	setCurrentProductId(state, value) {
		// let state = JSON.parse(JSON.stringify(state))
		state.currentProductId = value
		// state = s
	},

	// 设置当前商品的属性值
	saveChooseInfo(state, info) {
		// let s = JSON.parse(JSON.stringify(state))
		state.chooseinfo = info
		// state = s
	},

	//点击促销信息， 弹出框的位置
	changePromotion(state, data) {
		// let state = JSON.parse(JSON.stringify(state))
		state.ispromotion = data
		// state = s
	},

	saveChooseInfo(state, info) {
		// let s = JSON.parse(JSON.stringify(state))
		state.chooseinfo = info
		// state = s
	},

	saveProperties(state, value) {
		// let s = JSON.parse(JSON.stringify(state))
		state.properties = value
		// state = s
	},

	// 改变当前是否是预览大图的值
	setisPreviewPicture(state, value) {
		// let s = JSON.parse(JSON.stringify(state))
		state.isPreviewPicture = value
		// state = s
	},

	setSwiperId(state, value) {
		// let s = JSON.parse(JSON.stringify(state))
		state.swipeId = value
		// state = s
	},

	changePopstatus(state, value) {
		// let s = JSON.parse(JSON.stringify(state))
		state.promoPopstatus = value
		// state = s
	}
}

export default {
	state,
	mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/detail.js